//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CardPropertyIcon from './CardPropertyIcon.vue'
import { cardPropertyMixin } from './CardPropertyMixin.js'
import { cardPropertyConfigurableMixin } from './CardPropertyConfigurableMixin.js'
import CardPropertyGeoPointEditor from './CardPropertyGeoPointEditor.vue'
import { settingsGUI } from '../../pages/main/sections/UserSettings/UserSettingsGUI.js'

export default {
  name: 'CardPropertyGeoPoint',
  components: {
    CardPropertyGeoPointEditor,
    CardPropertyIcon
  },
  mixins: [settingsGUI, cardPropertyMixin, cardPropertyConfigurableMixin],
  data: function () {
    return {
      editorOpened: false,
      editorValue: null,
      editorValueValid: false
    }
  },
  computed: {
    coordsRaw: function () {
      if (this.object) {
        return this.object[this.tabProp.key]
      }
      return null
    },
    coordsText: function () {
      return this.getTextValue(this.coordsRaw)
    },
    copyAvailable: function () {
      const config = this.tabProp || {}
      return config.componentProps && config.componentProps.copy
    },
    yandexMapsLocationURL: function () {
      if (this.coordsRaw && this.coordsRaw.length) {
        return this.$d.getYandexMapsLocationUrl(this.coordsRaw[0])
      }
      return null
    },
    yandexNavigatorHref: function () {
      if (this.coordsRaw && this.coordsRaw.length) {
        return this.$d.getNavigatorHref(this.coordsRaw[0], 'yandex')
      }
      return null
    },
    googleNavigatorHref: function () {
      if (this.coordsRaw && this.coordsRaw.length) {
        return this.$d.getNavigatorHref(this.coordsRaw[0], 'google')
      }
      return null
    },
    gisNavigatorHref: function () {
      if (this.coordsRaw && this.coordsRaw.length) {
        return this.$d.getNavigatorHref(this.coordsRaw[0], '2gis')
      }
      return null
    },
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    }
  },
  methods: {
    getTextValue: function (objectValue) {
      if (objectValue && objectValue.length) {
        return this.formatCoords(objectValue[0])
      }
      return null
    },

    onEdit: function () {
      this.editorValue = this.coordsRaw && this.coordsRaw.length ? [this.coordsRaw[0].slice()] : [[null, null]]
      this.editorOpened = true
    },
    onCopy: function (e) {
      e.stopPropagation()
      const data = [new window.ClipboardItem({ 'text/plain': new Blob([this.coordsText], { type: 'text/plain' }) })]
      navigator.clipboard.write(data)
    },
    onApplyChanges: function () {
      this.object[this.tabProp.key] = this.editorValue
      this.editorOpened = false
    },
    onOpenLink: function (href) {
      if (href) {
        window.open(href, '_blank')
      }
    }
  }
}
